export default __webpack_public_path__ + "static/mona-98fcdd1dcc88f9a944c6ceca384f3220.png";